import apiClient from '../../apiClient';
import apiClientCyberSource from '../../apiClient';
import { createError, UNABLE_TO_CONTACT_PROVIDER } from '../../util';
import BookingConfirmmationRequest, {
  BookingConfirmationResponse,
  PaymentContextResponse,
  PaymentContextPayload,
  // eslint-disable-next-line prettier/prettier
  PaymentSubmitResponse,
  PaymentAndBookingRequest,
} from './types';

const CONFIRM_API_ENDPOINT: string = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_CONFIRM_API_PATH}`;
const PAYMENT_CONTEXT_ENDPOINT = `${process.env.REACT_APP_PAYMENT_CONTEXT_ENDPOINT}`;
const PAYMENT_SUBMISSION_ENDPOINT = process.env.REACT_APP_MAKE_PAYMENT_ENDPOINT || '';
export const commitReservation = async (request: BookingConfirmmationRequest): Promise<BookingConfirmationResponse> => {
  const returnValue: BookingConfirmationResponse = {
    hasError: false,
  };
  try {
    const response: BookingConfirmationResponse = await apiClient.post<
      BookingConfirmmationRequest,
      BookingConfirmationResponse
    >(CONFIRM_API_ENDPOINT, request);
    returnValue.ConfirmationNumber = response.ConfirmationNumber;
  } catch (e: any) {
    returnValue.hasError = true;
    returnValue.tokenExpired = e.response && e.response.tokenExpired && e.response.tokenExpired === true ? true : false;
    if (e.response && e.response.data && e.response.data.errorCode) {
      const {
        response: {
          data: { errorCode },
        },
      } = e;
      returnValue.error = createError(errorCode);
    } else {
      returnValue.error = createError('');
    }
  }

  return returnValue;
};
export const getPaymentContext = async (merchanrGroupId: string, origin: string): Promise<PaymentContextResponse> => {
  const requestUrl = `${PAYMENT_CONTEXT_ENDPOINT}?merchantGroupId=${merchanrGroupId}`;
  const requestPayload: any = {
    targetOrigins: [origin],
  };
  const returnValue: PaymentContextResponse = {
    hasError: false,
  };
  function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }
  try {
    const response = await apiClientCyberSource.postCyberSource<PaymentContextPayload, PaymentContextResponse>(
      requestUrl,
      requestPayload,
    );
    returnValue.status = response.status;
    returnValue.contextTokens = response.contextTokens;
    const cyberSourceToken = returnValue.contextTokens && returnValue.contextTokens[0].key;
    const clientLibraryJwt = cyberSourceToken && parseJwt(cyberSourceToken).ctx[0].data.clientLibrary;
    const clientLibraryIntegrityJwt = cyberSourceToken && parseJwt(cyberSourceToken).ctx[0].data.clientLibraryIntegrity;
    // create script tag
    const script = document.createElement('script');
    script.src = clientLibraryJwt;
    script.type = 'text/javascript';
    script.id = 'cyberSource';
    script.async = true;
    script.integrity = clientLibraryIntegrityJwt;
    script.crossOrigin = 'anonymous';
    // run setup code after script has loaded successfully
    script.onload = function () {
      // SETUP
    };
    if (!document.getElementById('cyberSource')) {
      // insert to document
      document.head.appendChild(script);
    }
    if (response.status !== 'success') {
      response.hasError = true;
    }
  } catch (e) {
    returnValue.hasError = true;
    returnValue.error = createError(UNABLE_TO_CONTACT_PROVIDER);
  }

  return returnValue;
};

export const submitPaymentAndBooking = async (req: PaymentAndBookingRequest): Promise<BookingConfirmationResponse> => {
  const returnValue: BookingConfirmationResponse = {
    hasError: false,
  };
  try {
    const response: BookingConfirmationResponse = await apiClient.post<PaymentAndBookingRequest, PaymentSubmitResponse>(
      PAYMENT_SUBMISSION_ENDPOINT,
      req,
    );
    returnValue.ConfirmationNumber = response.ConfirmationNumber;
  } catch (e: any) {
    returnValue.hasError = true;
    returnValue.tokenExpired = e.response && e.response.tokenExpired && e.response.tokenExpired === true ? true : false;
    if (e.response && e.response.data && e.response.data.errorCode) {
      const {
        response: {
          data: { errorCode },
        },
      } = e;
      returnValue.error = createError(errorCode);
    } else {
      returnValue.error = createError('');
    }
  }

  return returnValue;
};
